import gql from 'graphql-tag';

export const ACTIVITIES_TITLES = gql`
  query activities($businessOwnerId: Int) {
    activities(
      numberOfActivityPerPage: 10000
      businessOwnerId: $businessOwnerId
    ) {
      id
      title
      titleNo
    }
  }
`;

export const ACTIVITIES_WITH_BOOKINGS = gql`
  query activities(
    $startPeriod: Date!
    $endPeriod: Date!
    $businessOwnerId: Int
  ) {
    activities(businessOwnerId: $businessOwnerId) {
      id
      title
      productCode
      scheduleType
      maxParticipants
      isPrivate
      schedule
      activityBookingsForPeriod(startDate: $startPeriod, endDate: $endPeriod) {
        id
        startingDate
        endingDate
        schedule
        guestFirstName
        guestLastName
        platform
        referenceNumber
        bookingType
        isCanceled
        isHandled
        creationTime
        cancellationTime
        checkInTime
        checkOutTime
        guests {
          guestsNumber
          totalPrice
          participant {
            participant
          }
        }
        payments {
          currency {
            currency
          }
          totalPrice
        }
        bookedAddOns {
          addOnCount
          totalPrice
          addOn {
            title
          }
        }
        activity {
          id
          title
          schedule
          isPrivate
          isOpen
          productCode
          pricesType
          futurePriceForm
          scheduleType
          maxParticipants
        }
      }
    }
  }
`;

export const ACTIVITIES = gql`
  query activities($page: Int, $businessOwnerId: Int) {
    activities(
      page: $page
      numberOfActivityPerPage: 11
      businessOwnerId: $businessOwnerId
    ) {
      id
      photo
      title
      availability
      schedule
      productCode
      startingPoint
      isOpen
      minParticipants
      maxParticipants
    }
    numberOfActivitiesPages(
      numberOfActivitiesPerPage: 11
      businessOwnerId: $businessOwnerId
    )
    accommodationsActivitiesOverview(businessOwnerId: $businessOwnerId) {
      activities {
        total
        available
        expired
      }
      accommodations {
        total
        available
        expired
      }
    }
  }
`;

export const WIDGET_ACTIVITIES = gql`
  query activities(
    $page: Int
    $businessOwnerId: Int
    $numberOfActivityPerPage: Int!
    $startPeriod: Date
    $endPeriod: Date
    $guestsNumber: Int
  ) {
    activities(
      page: $page
      businessOwnerId: $businessOwnerId
      numberOfActivityPerPage: $numberOfActivityPerPage
      startPeriod: $startPeriod
      endPeriod: $endPeriod
      guestsNumber: $guestsNumber
    ) {
      id
      photo
      title
      titleNo

      overview
      overviewNo
      whatToBring
      whatToBringNo
      additionalInfo
      additionalInfoNo
      cancellation
      cancellationNo
      included
      includedNo
      notIncluded
      notIncludedNo
      minimalNight

      maxParticipants
      startingPoint
      scheduleType
      pricesType
      futurePriceForm
      prices {
        id
        participant {
          participant
        }
        currency {
          currency
        }
        days
        value
      }
      futurePrices {
        id
        ratePlan {
          id
          title
        }
        ratePlanPrices {
          id
          value
          currency {
            currency
          }
          participant {
            participant
          }
          startDate
          endDate
        }
      }
    }
    numberOfActivitiesPages(
      businessOwnerId: $businessOwnerId
      numberOfActivitiesPerPage: $numberOfActivityPerPage
    )
  }
`;

export const ACTIVITY = gql`
  query activities($activityId: Int, $businessOwnerId: Int) {
    activities(activityId: $activityId, businessOwnerId: $businessOwnerId) {
      id
      scheduleType
      pricesType
      futurePriceForm

      photo
      title
      titleNo
      productCode
      isOpen
      minParticipants
      maxParticipants
      startingPoint

      overview
      overviewNo
      whatToBring
      whatToBringNo
      additionalInfo
      additionalInfoNo
      cancellation
      cancellationNo
      included
      includedNo
      notIncluded
      notIncludedNo

      schedule

      activitybookingSet {
        id
        deactivationBooking
        endingDate
        startingDate
        isCanceled
      }

      prices {
        id
        participant {
          participant
        }
        currency {
          currency
        }
        days
        value
      }
      futurePrices {
        id
        ratePlan {
          id
          title
        }
        ratePlanPrices {
          id
          value
          currency {
            currency
          }
          participant {
            participant
          }
          startDate
          endDate
        }
      }

      addOns {
        id
        title
        titleNo
        description
        descriptionNo
        photo
        prices {
          currency {
            currency
          }
          value
        }
      }

      relatedAccommodations {
        id
        title
        titleNo
        overview
        overviewNo
        photo
        checkInTime
        checkOutTime
        prices {
          id
          participant {
            participant
          }
          currency {
            currency
          }
          value
          day
        }
        futurePrices {
        id
        ratePlan {
          id
          title
        }
        ratePlanPrices {
          id
          value
          currency {
            currency
          }
          startDate
          endDate
        }
      }  
      }
       
      platforms {
        id
        platform
        titleOnPlatform
      }
    }
  }
`;

export const ACTIVITIES_AVAILABLE_PARTICIPANTS = gql`
  query activities(
    $activityId: Int
    $businessOwnerId: Int
    $startPeriod: Date!
    $endPeriod: Date!
  ) {
    activities(activityId: $activityId, businessOwnerId: $businessOwnerId) {
      availableParticipantsPerDate(
        startPeriod: $startPeriod
        endPeriod: $endPeriod
      ) {
        date
        startTime
        availableParticipants
      }
    }
  }
`;


export const GET_ACTIVITY_RATE_PLANS = gql`
  query GetRatePlans($businessOwnerId: Int) {
    activityRatePlans(businessOwnerId: $businessOwnerId) {
      id
      title
      prices {
        currency {
          currency
        }
        participant {
          participant
        }
        value
        startDate
        endDate
      }
    }
  }
`;